import {store} from "./store";
import {set_token} from "../modules/nite_api";

store.subscribe(
    (mutation) => {

        switch (mutation.type) {
            case 'auth/SET_TOKEN':
                if (mutation.payload) {
                    set_token(mutation.payload);

                    localStorage.setItem('token', mutation.payload);

                } else {
                    set_token(null);
                    localStorage.removeItem('token');

                }
                break;
            case 'auth/SET_REFRESH_TOKEN':
                if (mutation.payload) {
                    localStorage.setItem('refresh_token', mutation.payload);

                } else {
                    localStorage.removeItem('refresh_token');

                }

        }
    }
)